import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SiteEffects } from './effects';
import { reducer, siteFeatureKey } from './reducer';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([SiteEffects]),
    StoreModule.forFeature(siteFeatureKey, reducer),
  ],
})
export class SiteModule {}
